import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanySupplyChainsTab } from '../../../-components/CompanySupplyChainsTab';
import { companySupplyChainsQueryOptions } from '../../../-hooks/useCompanySupplyChains';
import { DEFAULT_PAGE_SIZE } from '../../../-utils/pagination';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/supply-chains/',
)({
  loader: ({ params }) =>
    queryClient
      .ensureQueryData(
        companySupplyChainsQueryOptions({
          companyId: params.companyId,
          page: 1,
          limit: DEFAULT_PAGE_SIZE,
        }),
      )
      // A failed prefetch must not blank the tab — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CompanySupplyChainsPage,
});

function CompanySupplyChainsPage() {
  const { companyId } = Route.useParams();
  return <CompanySupplyChainsTab companyId={companyId} />;
}
